export const UserApiEndpoint = {
  fetchMobileVoucherInfo: '/ticket', // 모바일 이용권 등록화면에서 기본값 가져오기
  registMobileVoucher: '/ticket', // 모바일 이용권 등록
  fetchMobileVoucherPurchaseList: '/ticket/user-tickets/purchase', // 모바일 이용권 구입 목록
  fetchMobileVoucherUseList: '/ticket/user-tickets/details', // 모바일 이용권 사용 목록
  fetchMobileVoucherList: '/ticket/user-tickets/list', // 모바일 이용권 사용 리스트 (NEW)
  fetchMobileVoucherDetail: '/ticket/user-tickets/:depositId', // 모바일 이용권 사용 리스트 (NEW)
  fetchGCardRegistList: '/user-deposit', // G카드 가입 조회
  fetchGCardPointList: '/user-history/visits', // G카드 포인트 조회
  fetchGCardPointSummary: '/user-history/visits/count', // G카드 포인트 요약
  withdrawalGCard: '/user-deposit/return', // G카드 탈퇴
};
